import { APP_INITIALIZER } from '@angular/core';
import { ReplaceableComponentsService } from '@abp/ng.core';
import { eAccountComponents } from '@abp/ng.account';
import { ManageProfileComponent } from './manage-profile/manage-profile.component';

/**
 * The commercial `ManageProfileTabsService` is not part of the free `@abp/ng.account`.
 * Instead we replace the whole manage-profile page with our local tabbed component, which
 * hosts Personal Info, Change Password and the custom Payment/Addresses/Settings tabs.
 */
export const MANAGE_PROFILE_TAB_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: (replaceableComponents: ReplaceableComponentsService) => () => {
    replaceableComponents.add({
      key: eAccountComponents.ManageProfile,
      component: ManageProfileComponent,
    });
  },
  deps: [ReplaceableComponentsService],
  multi: true,
};
